document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('.progress-counter__item-counter span');
  const bars = document.querySelectorAll('.progress-counter__item-bar-inner');

  const animateCount = (el, target) => {
    const duration = 1500;
    const startTime = performance.now();

    const step = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = Math.floor(progress * target);

      el.textContent = value.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target.toLocaleString();
      }
    };

    requestAnimationFrame(step);
  };

  const animateBar = (el) => {
    const targetWidth = el.getAttribute('data-width');
    const targetHeight = el.getAttribute('data-height');

    if (targetWidth !== null) {
      el.style.width = '0%';
      el.style.transition = 'width 1.5s ease';

      requestAnimationFrame(() => {
        el.style.width = targetWidth + '%';
      });
    }

    if (targetHeight !== null) {
      el.style.height = '0%';
      el.style.transition = 'height 1.5s ease';

      requestAnimationFrame(() => {
        el.style.height = targetHeight + '%';
      });
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;

        if (el.matches('.progress-counter__item-counter span')) {
          const targetValue = parseInt(el.getAttribute('data-counter'), 10);

          if (!el.classList.contains('counted')) {
            el.classList.add('counted');
            animateCount(el, targetValue);
          }
        }

        if (el.matches('.progress-counter__item-bar-inner')) {
          const targetWidth = parseInt(el.getAttribute('data-width'), 10);

          if (!el.classList.contains('animated')) {
            el.classList.add('animated');
            animateBar(el, targetWidth);
          }
        }
      }
    });
  }, {
    threshold: 0.5
  });

  counters.forEach(counter => observer.observe(counter));
  bars.forEach(bar => observer.observe(bar));
});
